// extracted by mini-css-extract-plugin
export default {"ag-styles":"c_g","aboutPage":"c_h","team":"c_j","footer":"c_k"};